<fui-radio-group [label]="label" [attr.id]="elementId" [bordered]="bordered">
    <fui-radio-control *ngIf="firstOption ? showTrueOption : showFalseOption"
                       [equivalent]="firstOption" [label]="firstOption ? trueLabel : falseLabel" [(ngModel)]="value"
                       [readOnly]="isReadonly" [name]="formControlName"></fui-radio-control>
    <fui-radio-control *ngIf="firstOption ? showFalseOption : showTrueOption"
                       [equivalent]="!firstOption" [label]="firstOption ? falseLabel : trueLabel" [(ngModel)]="value"
                       [readOnly]="isReadonly" [name]="formControlName"></fui-radio-control>
</fui-radio-group>
